import { useCaseQueue } from "src/cases/queries/queues";
import {
  CaseTemplateQueryResults,
  useCaseTemplatesByIds,
} from "src/cases/queries/templates";
import { CaseQueueColumnSchemas } from "src/cases/queues/types";
import { extractQueueColumnSchemas } from "src/cases/queues/utils";

type UseQueueColumnSchemasResult = {
  columnSchemas: CaseQueueColumnSchemas;
  isLoading: boolean;
};

const combineToColumnSchemas = (
  results: CaseTemplateQueryResults,
): UseQueueColumnSchemasResult => ({
  columnSchemas: extractQueueColumnSchemas(
    results.flatMap((r) => r.data?.versions ?? []),
  ),
  isLoading: results.some((r) => r.isLoading),
});

export const useQueueColumnSchemas = (
  queueId: string | undefined,
): UseQueueColumnSchemasResult => {
  const { data: caseQueue, isLoading: isLoadingQueue } = useCaseQueue(queueId);

  const templateIds =
    caseQueue?.template_configs?.map((config) => config.template.id) ?? [];

  const { columnSchemas, isLoading: isLoadingTemplates } =
    useCaseTemplatesByIds(templateIds, { combine: combineToColumnSchemas });

  return {
    columnSchemas,
    isLoading: isLoadingQueue || isLoadingTemplates,
  };
};
